import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
/* common */
import MainLayout from "src/MainLayout";
import HomePage from "src/pages/HomePage";
import SearchResult from "src/pages/SearchResult";
import NotFound from "src/shared/NotFound";
/* movies */
import NowPlaying from "src/pages/NowPlaying";
import ComingSoon from "src/pages/ComingSoon";
import PopularMovies from "src/pages/PopularMovies";
import TopRated from "src/pages/TopRated";
import MovieDetail from "src/pagesDetail/MovieDetail";

/* tv shows */
import PopularShows from "src/pages/PopularShows";
import AiringToday from "src/pages/AiringToday";
import OnTheAir from "src/pages/OnTheAir";
import TopRatedShows from "src/pages/TopRatedShows";
import ShowDetail from "src/pagesDetail/ShowDetail";
import EpisodesDetail from "src/pagesDetail/EpisodesDetail";

/*Popular people*/
import PopularPeople from "src/pages/PopularPeople";
import PersonDetail from "src/pagesDetail/PersonDetail";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<MainLayout />}>
      <Route index element={<HomePage />} />
      <Route path="nowPlaying/:currentPage" element={<NowPlaying />} />
      <Route path="comingsoon/:currentPage" element={<ComingSoon />} />
      <Route path="popularmovies/:currentPage" element={<PopularMovies />} />
      <Route path="topratedmovies/:currentPage" element={<TopRated />} />
      <Route
        path=":movieType?/:currentPage?/movieDetail/:id/:movieTitle"
        element={<MovieDetail />}
      />
      <Route path="popular_shows/:currentPage" element={<PopularShows />} />
      <Route path="airing_today/:currentPage" element={<AiringToday />} />
      <Route path="on_the_air/:currentPage" element={<OnTheAir />} />
      <Route path="top_rated_shows/:currentPage" element={<TopRatedShows />} />
      <Route
        path=":showType?/:currentPage?/showDetail/:id/:showName"
        element={<ShowDetail />}
      />
      <Route
        path=":showType?/:currentPage?/showDetail/:id/:showName/seasons/:seasonCount"
        element={<EpisodesDetail />}
      />
      <Route path="popularpeople/:currentPage" element={<PopularPeople />} />
      <Route
        path=":personType?/:currentPage?/personDetail/:id/:name"
        element={<PersonDetail />}
      />
      <Route path="search/:query" element={<SearchResult />} />
      <Route path="*" element={<NotFound />} />
    </Route>,
  ),
);
const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
